import { SelectField } from './SelectField';

import { createFormikField } from 'components/fields/utils/createFormikField';

export const FormikSelectField = createFormikField(SelectField);
